import { render, staticRenderFns } from "./CGU.vue?vue&type=template&id=6b4183ae&scoped=true&"
var script = {}
import style0 from "./CGU.vue?vue&type=style&index=0&id=6b4183ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4183ae",
  null
  
)

export default component.exports